'use client';

import _defineProperty from "/codebuild/output/src2869/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/codebuild/output/src2869/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src2869/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["orientation"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useState } from 'react';
import '@mantine/hooks';
import 'clsx';
import '../../../core/MantineProvider/Mantine.context.mjs';
import '../../../core/MantineProvider/default-theme.mjs';
import '../../../core/MantineProvider/MantineProvider.mjs';
import '../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import '../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import '../../../core/Box/Box.mjs';
import { useDirection } from '../../../core/DirectionProvider/DirectionProvider.mjs';
import { useScrollAreaContext } from '../ScrollArea.context.mjs';
import { getThumbRatio } from '../utils/get-thumb-ratio.mjs';
import { getThumbOffsetFromScroll } from '../utils/get-thumb-offset-from-scroll.mjs';
import { getScrollPositionFromPointer } from '../utils/get-scroll-position-from-pointer.mjs';
import { ScrollAreaScrollbarX } from './ScrollbarX.mjs';
import { ScrollAreaScrollbarY } from './ScrollbarY.mjs';
var ScrollAreaScrollbarVisible = forwardRef(function (props, forwardedRef) {
  var _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? "vertical" : _props$orientation,
    scrollbarProps = _objectWithoutProperties(props, _excluded);
  var _useDirection = useDirection(),
    dir = _useDirection.dir;
  var context = useScrollAreaContext();
  var thumbRef = useRef(null);
  var pointerOffsetRef = useRef(0);
  var _useState = useState({
      content: 0,
      viewport: 0,
      scrollbar: {
        size: 0,
        paddingStart: 0,
        paddingEnd: 0
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    sizes = _useState2[0],
    setSizes = _useState2[1];
  var thumbRatio = getThumbRatio(sizes.viewport, sizes.content);
  var commonProps = _objectSpread(_objectSpread({}, scrollbarProps), {}, {
    sizes: sizes,
    onSizesChange: setSizes,
    hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
    onThumbChange: function onThumbChange(thumb) {
      thumbRef.current = thumb;
    },
    onThumbPointerUp: function onThumbPointerUp() {
      pointerOffsetRef.current = 0;
    },
    onThumbPointerDown: function onThumbPointerDown(pointerPos) {
      pointerOffsetRef.current = pointerPos;
    }
  });
  var getScrollPosition = function getScrollPosition(pointerPos, direction) {
    return getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, direction);
  };
  if (orientation === "horizontal") {
    return /* @__PURE__ */jsx(ScrollAreaScrollbarX, _objectSpread(_objectSpread({}, commonProps), {}, {
      ref: forwardedRef,
      onThumbPositionChange: function onThumbPositionChange() {
        if (context.viewport && thumbRef.current) {
          var scrollPos = context.viewport.scrollLeft;
          var offset = getThumbOffsetFromScroll(scrollPos, sizes, dir);
          thumbRef.current.style.transform = "translate3d(".concat(offset, "px, 0, 0)");
        }
      },
      onWheelScroll: function onWheelScroll(scrollPos) {
        if (context.viewport) context.viewport.scrollLeft = scrollPos;
      },
      onDragScroll: function onDragScroll(pointerPos) {
        if (context.viewport) {
          context.viewport.scrollLeft = getScrollPosition(pointerPos, dir);
        }
      }
    }));
  }
  if (orientation === "vertical") {
    return /* @__PURE__ */jsx(ScrollAreaScrollbarY, _objectSpread(_objectSpread({}, commonProps), {}, {
      ref: forwardedRef,
      onThumbPositionChange: function onThumbPositionChange() {
        if (context.viewport && thumbRef.current) {
          var scrollPos = context.viewport.scrollTop;
          var offset = getThumbOffsetFromScroll(scrollPos, sizes);
          if (sizes.scrollbar.size === 0) {
            thumbRef.current.style.opacity = "0";
          } else {
            thumbRef.current.style.opacity = "1";
          }
          thumbRef.current.style.transform = "translate3d(0, ".concat(offset, "px, 0)");
        }
      },
      onWheelScroll: function onWheelScroll(scrollPos) {
        if (context.viewport) context.viewport.scrollTop = scrollPos;
      },
      onDragScroll: function onDragScroll(pointerPos) {
        if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
      }
    }));
  }
  return null;
});
export { ScrollAreaScrollbarVisible };